import idx from 'idx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers, lifecycle } from 'recompose'
import withMixpanel, { SCREEN_VIEW_CREATE_ORGANISATION } from 'utils/mixpanel'

import * as userActions from 'actions/userActions'
import * as organisationModule from 'modules/organisation'

export default compose(
  withMixpanel,
  connect(
    (state) => {
      return {
        hasError: idx(state, _ => _.progress.createOrganisation.hasError) || false,
        errorMessage: idx(state, _ => _.progress.login.createOrganisation.message) || null,
      }
    },
    (dispatch) => {
      const actions = {
        ...userActions,
        ...organisationModule,
      }

      return {
        actions: bindActionCreators(actions, dispatch),
      }
    },
  ),
  // Handlers
  withHandlers({
    onFormSubmit: props => (organisationFields) => {
      props.actions.createOrganisation(organisationFields)
    },
    onBackPress: props => () => {
      props.history.goBack()
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.track(SCREEN_VIEW_CREATE_ORGANISATION)
    }
  })
)



// WEBPACK FOOTER //
// ./src/containers/organisation/CreateOrganisation/CreateOrganisation.enhancer.js